import React, { useEffect, useState } from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Mission, MissionPanels } from './components/Mission';
import { CommunityStrength } from './components/CommunityStrength';
import { Leadership } from './components/Leadership';
import { AdvisoryCouncil } from './components/AdvisoryCouncil';
import { MakeDifferenceCTA } from './components/MakeDifferenceCTA';
import { NewsBlog } from './components/NewsBlog';
import { NonprofitScroller } from './components/NonprofitScroller';
import { HondurasFacts } from './components/HondurasFacts';
import { MediaScroller } from './components/MediaScroller';
import { ConsularAffairs } from './components/ConsularAffairs';
import { BusinessInvestments } from './components/BusinessInvestments';
import { NonprofitDirectory } from './components/NonprofitDirectory';
import { ExploreHonduras } from './components/ExploreHonduras';
import { HondurasQuiz } from './components/HondurasQuiz';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { Events } from './components/Events';
import { ConsularBanner } from './components/ConsularBanner';
import { LandingPage } from './components/LandingPage';
import { SocialMediaVoices } from './components/SocialMediaVoices';
import { AdminDashboard } from './components/AdminDashboard';
import { useLanguage } from './contexts/LanguageContext';
import { FeedbackPopup } from './components/FeedbackPopup';
import { ConsularPage } from './pages/ConsularPage';
import { BusinessMapPage } from './pages/BusinessMapPage';
import { SectionAccordion } from './components/SectionAccordion';
function AppContent({
  showLanding,
  setShowLanding
}: {
  showLanding: boolean;
  setShowLanding: (v: boolean) => void;
}) {
  const {
    language,
    setLanguage
  } = useLanguage();
  const [pendingScroll, setPendingScroll] = useState<string | null>(null);
  const handleSelectLanguage = (lang: 'EN' | 'ES') => {
    setLanguage(lang);
    setShowLanding(false);
  };
  const handleConsularAccess = (lang: 'EN' | 'ES') => {
    setLanguage(lang);
    setShowLanding(false);
    setPendingScroll('consular-affairs');
  };
  useEffect(() => {
    if (!showLanding && pendingScroll) {
      const timer = setTimeout(() => {
        const el = document.getElementById(pendingScroll);
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth'
          });
        }
        setPendingScroll(null);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [showLanding, pendingScroll]);
  if (showLanding) {
    return <LandingPage onSelectLanguage={handleSelectLanguage} onConsularAccess={handleConsularAccess} data-id="element-0" />;
  }
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-1">
      <Navbar data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <ConsularBanner data-id="element-5" />
        <Mission data-id="element-6" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex flex-col gap-4" data-id="element-7">
          <SectionAccordion title="Latest News" titleEs="Últimas Noticias" bgColor="bg-gray-50" borderColor="border-gray-200" textColor="text-gray-800" iconColor="text-gray-500" previewImages={['https://cdn.magicpatterns.com/uploads/fHxDU8pQHwJzowjDkpYge5/IMG_4455.jpg', 'https://cdn.magicpatterns.com/uploads/ew97atokoCc3satNApke4W/SoA_1.jpg', 'https://cdn.magicpatterns.com/uploads/bGuGogi7aKTRBxk7ELEbiK/Ciadi_1.jpg', 'https://cdn.magicpatterns.com/uploads/iJ4t8AL121gTHUu1xzzQx4/USTDA.jpg', 'https://cdn.magicpatterns.com/uploads/a79cX8GF9Z8Zr2wnP6ymup/Garifuna-Collective-1200x628.jpg', 'https://cdn.magicpatterns.com/uploads/jiGXG6xB7qfM8n3G59eizj/rflores_Ambassador.jpg', 'https://cdn.magicpatterns.com/uploads/75m7ELyNuDt8sj37WnjoPs/daca_BC_056_111219-4.jpg', 'https://cdn.magicpatterns.com/uploads/mrfShjrpgdKKhd4SXuv4rX/Screenshot_2026-03-02_at_11.13.16_PM.png', 'https://cdn.magicpatterns.com/uploads/qK2Q5NDctMNP45cZYr9udX/IMG_3984.jpg', 'https://cdn.magicpatterns.com/uploads/bo3zBba1TsMyKsx9xDZJx6/Screenshot_2026-03-02_at_11.56.16_PM.png']} data-id="element-8">
            <NewsBlog data-id="element-9" />
            <MediaScroller data-id="element-10" />
          </SectionAccordion>

          <SectionAccordion title="Community Strengths" titleEs="Fortalezas Comunitarias" bgColor="bg-gray-100" borderColor="border-gray-300" textColor="text-gray-800" iconColor="text-gray-500" data-id="element-11">
            <CommunityStrength data-id="element-12" />
          </SectionAccordion>

          <SectionAccordion title="How We Rise" titleEs="Cómo Nos Elevamos" bgColor="bg-gray-200" borderColor="border-gray-300" textColor="text-gray-800" iconColor="text-gray-500" previewBadges={[{
          number: '01',
          label: 'Connect',
          labelEs: 'Conectar',
          bg: 'bg-haa-blue'
        }, {
          number: '02',
          label: 'Empower',
          labelEs: 'Empoderar',
          bg: 'bg-haa-midblue'
        }, {
          number: '03',
          label: 'Celebrate',
          labelEs: 'Celebrar',
          bg: 'bg-haa-navy'
        }]} data-id="element-13">
            <MissionPanels data-id="element-14" />
          </SectionAccordion>

          <SectionAccordion title="Our Leadership" titleEs="Nuestro Liderazgo" bgColor="bg-blue-50" borderColor="border-blue-200" textColor="text-blue-900" iconColor="text-blue-400" previewPeople={[{
          name: 'Jay Miranda',
          photo: 'https://cdn.magicpatterns.com/uploads/ofJcAH8pUUTZDWtToZFexG/JM_New.png'
        }, {
          name: 'Sindy Benavides',
          photo: 'https://cdn.magicpatterns.com/uploads/5XV2d7mCxX2q194xX3o4Lg/SindyNew.png'
        }, {
          name: 'Mario Ramos',
          photo: 'https://cdn.magicpatterns.com/uploads/jirqUvB3nUJVCELUZXoxvi/Mramos_Bio.jpg'
        }, {
          name: 'Carlos Campos',
          photo: 'https://cdn.magicpatterns.com/uploads/vJzX5jY2U1DYFZgtXRzwfp/Carlos_Campos_Profile.jpg'
        }, {
          name: 'Sal Mendosa',
          photo: 'https://cdn.magicpatterns.com/uploads/mSfXRaPLR5vsG8mfsDSLze/SMendoza_Headshot.png'
        }, {
          name: 'Shin Fujiyama',
          photo: 'https://cdn.magicpatterns.com/uploads/dVdJ4tiMDPrAvo4SeymQqc/Shin_Pic.png'
        }, {
          name: 'Eva Callejas',
          photo: 'https://cdn.magicpatterns.com/uploads/w99BmRAVRdGsXGQqgnMPrp/Eva_Pic.png'
        }, {
          name: 'Diana Brown',
          photo: 'https://cdn.magicpatterns.com/uploads/8WtmbUze1LwXtbXxojZsjD/Diana_Pic.png'
        }, {
          name: 'Jose Quiroz',
          photo: 'https://cdn.magicpatterns.com/uploads/oPQ7qAuAvm777pjMfuJg4i/JQuiroz_BioPic.png'
        }]} data-id="element-15">
            <Leadership data-id="element-16" />
            <AdvisoryCouncil data-id="element-17" />
          </SectionAccordion>

          <SectionAccordion title="Business &amp; Investments" titleEs="Negocios e Inversiones" bgColor="bg-blue-100" borderColor="border-blue-200" textColor="text-blue-900" iconColor="text-blue-400" data-id="element-18">
            <BusinessInvestments data-id="element-19" />
          </SectionAccordion>

          <SectionAccordion title="Consular Affairs" titleEs="Asuntos Consulares" bgColor="bg-blue-200" borderColor="border-blue-300" textColor="text-blue-900" iconColor="text-blue-500" data-id="element-20">
            <ConsularAffairs data-id="element-21" />
          </SectionAccordion>

          <SectionAccordion title="Uplifting Voices" titleEs="Voces Destacadas" bgColor="bg-blue-300" borderColor="border-blue-400" textColor="text-blue-950" iconColor="text-blue-600" data-id="element-22">
            <SocialMediaVoices data-id="element-23" />
          </SectionAccordion>

          <SectionAccordion title="Nonprofit Directory" titleEs="Directorio de Organizaciones" bgColor="bg-blue-500" borderColor="border-blue-600" textColor="text-white" iconColor="text-blue-100" data-id="element-24">
            <NonprofitDirectory data-id="element-25" />
          </SectionAccordion>

          <SectionAccordion title="Honduras Trivia" titleEs="Trivia de Honduras" bgColor="bg-blue-600" borderColor="border-blue-700" textColor="text-white" iconColor="text-blue-200" data-id="element-26">
            <HondurasQuiz data-id="element-27" />
          </SectionAccordion>

          <SectionAccordion title="Explore Honduras" titleEs="Explora Honduras" bgColor="bg-blue-700" borderColor="border-blue-800" textColor="text-white" iconColor="text-blue-200" data-id="element-28">
            <ExploreHonduras data-id="element-29" />
          </SectionAccordion>

          <SectionAccordion title="Frequently Asked Questions" titleEs="Preguntas Frecuentes" bgColor="bg-blue-900" borderColor="border-blue-950" textColor="text-white" iconColor="text-blue-300" data-id="element-30">
            <FAQ data-id="element-31" />
          </SectionAccordion>
        </div>

        <MakeDifferenceCTA data-id="element-32" />
      </main>
      <Footer data-id="element-33" />
      <FeedbackPopup data-id="element-34" />
    </div>;
}
export function App() {
  const [showLanding, setShowLanding] = useState(true);
  const [showAdmin, setShowAdmin] = useState(() => window.location.hash === '#/admin');
  const [showConsular, setShowConsular] = useState(() => window.location.hash === '#/consular');
  const [showBusinessMap, setShowBusinessMap] = useState(() => window.location.hash === '#/business-map');
  useEffect(() => {
    const handleHash = () => {
      const hash = window.location.hash;
      setShowAdmin(hash === '#/admin');
      setShowConsular(hash === '#/consular');
      setShowBusinessMap(hash === '#/business-map');
      // When navigating back to root from a sub-page, skip the landing page
      if (hash === '' || hash === '#') {
        setShowLanding(false);
      }
    };
    window.addEventListener('hashchange', handleHash);
    return () => window.removeEventListener('hashchange', handleHash);
  }, []);
  const handleReturnToLanding = () => {
    setShowLanding(true);
  };
  if (showAdmin) {
    return <AdminDashboard onBack={() => {
      window.location.hash = '';
      setShowAdmin(false);
    }} data-id="element-35" />;
  }
  if (showConsular) {
    return <LanguageProvider onLanguageSwitch={handleReturnToLanding} data-id="element-36">
        <ConsularPage data-id="element-37" />
      </LanguageProvider>;
  }
  if (showBusinessMap) {
    return <LanguageProvider onLanguageSwitch={handleReturnToLanding} data-id="element-38">
        <BusinessMapPage data-id="element-39" />
      </LanguageProvider>;
  }
  return <LanguageProvider onLanguageSwitch={handleReturnToLanding} data-id="element-40">
      <AppContent showLanding={showLanding} setShowLanding={setShowLanding} data-id="element-41" />
    </LanguageProvider>;
}